const guestTranslations = {
  it: {
    pageTitle: 'Registrazione Ospiti',
    subtitle: 'Registrazione obbligatoria e tassa di soggiorno',
    surname: 'Cognome',
    name: 'Nome',
    email: 'Email',
    birthDate: 'Data di nascita',
    arrivalDate: 'Data di arrivo',
    departureDate: 'Data di partenza',
    nationality: 'Nazionalità',
    documentType: 'Tipo di documento',
    passport: 'Passaporto',
    identityCard: 'Carta d\'identità',
    other: 'Altro',
    documentUpload: 'Carica documento d\'identità',
    documentUploadHint: 'Foto o PDF del documento (JPG, JPEG, PNG, PDF)',
    documentUploading: 'Caricamento in corso...',
    documentUploaded: 'Documento caricato',
    documentRequired: 'Il caricamento del documento d\'identità è obbligatorio',
    documentPrivacy: 'La copia del documento sarà utilizzata esclusivamente per finalità di identificazione, trattata con riservatezza e cancellata definitivamente dopo il soggiorno.',
    documentRedactHint: 'Se preferisci, puoi oscurare le informazioni sensibili sul tuo documento, come il numero del documento. Tuttavia, i seguenti dati sono obbligatori e devono essere chiaramente visibili: nome, cognome e data di nascita, come richiesto dalla legge svizzera per la registrazione degli ospiti.',
    adultCompanions: 'Quanti accompagnatori viaggiano con te (14 anni o più)?',
    childCompanions: 'Quanti accompagnatori viaggiano con te (sotto i 14 anni)?',
    selectCompanions: 'Seleziona',
    companionsRequired: 'Seleziona il numero di accompagnatori per entrambe le categorie',
    submit: 'Invia registrazione',
    submitting: 'Invio in corso...',
    required: 'Tutti i campi obbligatori devono essere compilati',
    invalidDates: 'La data di partenza deve essere successiva alla data di arrivo',
    searchNationality: 'Cerca nazionalità...',
    residenceCountry: 'Nazione di residenza',
    searchResidence: 'Cerca nazione di residenza...',
    // Tax page
    taxTitle: 'Tassa di soggiorno',
    nights: 'Numero di notti',
    taxableGuests: 'Ospiti tassabili (14+ anni)',
    taxRate: 'Tariffa per notte per persona',
    totalTax: 'Totale tassa di soggiorno',
    commission: 'Commissione di transazione',
    totalPayment: 'Totale da pagare',
    proceedPayment: 'Procedi al pagamento',
    taxNote: 'La tassa di soggiorno è un contributo obbligatorio imposto dal Comune e dalle autorità locali a chi soggiorna in strutture turistiche.',
    // Payment page
    paymentTitle: 'Pagamento tassa di soggiorno',
    paymentProcessing: 'Elaborazione pagamento in corso...',
    paymentRedirect: 'Verrai reindirizzato al sistema di pagamento sicuro.',
    payNow: 'Paga ora',
    // Confirmation page
    confirmTitle: 'Pagamento completato con successo',
    confirmCheckingPayment: 'Verifica pagamento in corso...',
    safebox: 'Il codice della safebox per recuperare le chiavi è:',
    saveCode: 'IMPORTANTE: salva o memorizza questo codice. Ti consigliamo di fare uno screenshot della schermata.',
    instructions: 'Tutte le foto e le istruzioni per raggiungere l\'appartamento ti sono già state inviate.',
    selfCheckin: 'Istruzioni Self Check-in',
    selfCheckinText: 'Utilizza il codice qui sopra per aprire la safebox e recuperare le chiavi del tuo appartamento.',
  },
  en: {
    pageTitle: 'Guest Registration',
    subtitle: 'Mandatory registration and tourist tax',
    surname: 'Surname',
    name: 'Name',
    email: 'Email',
    birthDate: 'Date of birth',
    arrivalDate: 'Arrival date',
    departureDate: 'Departure date',
    nationality: 'Nationality',
    documentType: 'Document type',
    passport: 'Passport',
    identityCard: 'Identity card',
    other: 'Other',
    documentUpload: 'Upload identity document',
    documentUploadHint: 'Photo or PDF of the document (JPG, JPEG, PNG, PDF)',
    documentUploading: 'Uploading...',
    documentUploaded: 'Document uploaded',
    documentRequired: 'Identity document upload is required',
    documentPrivacy: 'The copy of the document will be used exclusively for identification purposes, treated confidentially and permanently deleted after the stay.',
    documentRedactHint: 'If you prefer, you can redact sensitive information on your document, such as the document number. However, the following data is mandatory and must be clearly visible: first name, surname and date of birth, as required by Swiss law for guest registration.',
    adultCompanions: 'How many accompanying guests are travelling with you (14 years old or older)?',
    childCompanions: 'How many accompanying guests are travelling with you (under 14 years old)?',
    selectCompanions: 'Select',
    companionsRequired: 'Please select the number of companions for both categories',
    submit: 'Submit registration',
    submitting: 'Submitting...',
    required: 'All required fields must be filled in',
    invalidDates: 'Departure date must be after arrival date',
    searchNationality: 'Search nationality...',
    residenceCountry: 'Country of residence',
    searchResidence: 'Search country of residence...',
    taxTitle: 'Tourist Tax',
    nights: 'Number of nights',
    taxableGuests: 'Taxable guests (14+ years)',
    taxRate: 'Rate per night per person',
    totalTax: 'Total tourist tax',
    commission: 'Transaction fee',
    totalPayment: 'Total to pay',
    proceedPayment: 'Proceed to payment',
    taxNote: 'The tourist tax is a mandatory contribution imposed by the Municipality and local authorities on those staying in tourist accommodation.',
    paymentTitle: 'Tourist Tax Payment',
    paymentProcessing: 'Processing payment...',
    paymentRedirect: 'You will be redirected to the secure payment system.',
    payNow: 'Pay now',
    confirmTitle: 'Payment completed successfully',
    confirmCheckingPayment: 'Checking payment status...',
    safebox: 'The safebox code to retrieve the keys is:',
    saveCode: 'IMPORTANT: save or memorize this code. We recommend taking a screenshot of this page.',
    instructions: 'All photos and instructions for reaching the apartment have already been sent to you.',
    selfCheckin: 'Self Check-in Instructions',
    selfCheckinText: 'Use the code above to open the safebox and retrieve your apartment keys.',
  },
  de: {
    pageTitle: 'Gästeregistrierung',
    subtitle: 'Obligatorische Registrierung und Kurtaxe',
    surname: 'Nachname',
    name: 'Vorname',
    email: 'E-Mail',
    birthDate: 'Geburtsdatum',
    arrivalDate: 'Anreisedatum',
    departureDate: 'Abreisedatum',
    nationality: 'Nationalität',
    documentType: 'Dokumenttyp',
    passport: 'Reisepass',
    identityCard: 'Personalausweis',
    other: 'Andere',
    documentUpload: 'Identitätsdokument hochladen',
    documentUploadHint: 'Foto oder PDF des Dokuments (JPG, JPEG, PNG, PDF)',
    documentUploading: 'Wird hochgeladen...',
    documentUploaded: 'Dokument hochgeladen',
    documentRequired: 'Das Hochladen des Identitätsdokuments ist erforderlich',
    documentPrivacy: 'Die Kopie des Dokuments wird ausschließlich zu Identifikationszwecken verwendet, vertraulich behandelt und nach dem Aufenthalt endgültig gelöscht.',
    documentRedactHint: 'Wenn Sie möchten, können Sie sensible Informationen auf Ihrem Dokument schwärzen, wie z.B. die Dokumentennummer. Folgende Daten sind jedoch obligatorisch und müssen deutlich sichtbar sein: Vorname, Nachname und Geburtsdatum, wie es das Schweizer Gesetz für die Gästeregistrierung vorschreibt.',
    adultCompanions: 'Wie viele Begleitpersonen reisen mit Ihnen (14 Jahre oder älter)?',
    childCompanions: 'Wie viele Begleitpersonen reisen mit Ihnen (unter 14 Jahre)?',
    selectCompanions: 'Auswählen',
    companionsRequired: 'Bitte wählen Sie die Anzahl der Begleitpersonen für beide Kategorien',
    submit: 'Registrierung absenden',
    submitting: 'Wird gesendet...',
    required: 'Alle Pflichtfelder müssen ausgefüllt werden',
    invalidDates: 'Das Abreisedatum muss nach dem Anreisedatum liegen',
    searchNationality: 'Nationalität suchen...',
    residenceCountry: 'Wohnsitzland',
    searchResidence: 'Wohnsitzland suchen...',
    taxTitle: 'Kurtaxe',
    nights: 'Anzahl Nächte',
    taxableGuests: 'Steuerpflichtige Gäste (14+ Jahre)',
    taxRate: 'Tarif pro Nacht pro Person',
    totalTax: 'Gesamte Kurtaxe',
    commission: 'Transaktionsgebühr',
    totalPayment: 'Zu zahlender Gesamtbetrag',
    proceedPayment: 'Zur Zahlung',
    taxNote: 'Die Kurtaxe ist ein obligatorischer Beitrag, der von der Gemeinde und den lokalen Behörden für Aufenthalte in touristischen Unterkünften erhoben wird.',
    paymentTitle: 'Zahlung der Kurtaxe',
    paymentProcessing: 'Zahlung wird bearbeitet...',
    paymentRedirect: 'Sie werden zum sicheren Zahlungssystem weitergeleitet.',
    payNow: 'Jetzt bezahlen',
    confirmTitle: 'Zahlung erfolgreich abgeschlossen',
    confirmCheckingPayment: 'Zahlungsstatus wird überprüft...',
    safebox: 'Der Safebox-Code zum Abholen der Schlüssel lautet:',
    saveCode: 'WICHTIG: Speichern oder merken Sie sich diesen Code. Wir empfehlen, einen Screenshot dieser Seite zu machen.',
    instructions: 'Alle Fotos und Anweisungen zur Anreise zum Apartment wurden Ihnen bereits zugesendet.',
    selfCheckin: 'Self Check-in Anleitung',
    selfCheckinText: 'Verwenden Sie den obigen Code, um die Safebox zu öffnen und Ihre Wohnungsschlüssel abzuholen.',
  },
  fr: {
    pageTitle: 'Enregistrement des hôtes',
    subtitle: 'Enregistrement obligatoire et taxe de séjour',
    surname: 'Nom de famille',
    name: 'Prénom',
    email: 'Email',
    birthDate: 'Date de naissance',
    arrivalDate: 'Date d\'arrivée',
    departureDate: 'Date de départ',
    nationality: 'Nationalité',
    documentType: 'Type de document',
    passport: 'Passeport',
    identityCard: 'Carte d\'identité',
    other: 'Autre',
    documentUpload: 'Télécharger le document d\'identité',
    documentUploadHint: 'Photo ou PDF du document (JPG, JPEG, PNG, PDF)',
    documentUploading: 'Téléchargement en cours...',
    documentUploaded: 'Document téléchargé',
    documentRequired: 'Le téléchargement du document d\'identité est obligatoire',
    documentPrivacy: 'La copie du document sera utilisée exclusivement à des fins d\'identification, traitée de manière confidentielle et définitivement supprimée après le séjour.',
    documentRedactHint: 'Si vous le souhaitez, vous pouvez masquer les informations sensibles sur votre document, comme le numéro du document. Cependant, les données suivantes sont obligatoires et doivent être clairement visibles: prénom, nom de famille et date de naissance, comme l\'exige la loi suisse pour l\'enregistrement des hôtes.',
    adultCompanions: 'Combien d\'accompagnants voyagent avec vous (14 ans ou plus)?',
    childCompanions: 'Combien d\'accompagnants voyagent avec vous (moins de 14 ans)?',
    selectCompanions: 'Sélectionner',
    companionsRequired: 'Veuillez sélectionner le nombre d\'accompagnants pour les deux catégories',
    submit: 'Soumettre l\'enregistrement',
    submitting: 'Envoi en cours...',
    required: 'Tous les champs obligatoires doivent être remplis',
    invalidDates: 'La date de départ doit être postérieure à la date d\'arrivée',
    searchNationality: 'Rechercher nationalité...',
    residenceCountry: 'Pays de résidence',
    searchResidence: 'Rechercher pays de résidence...',
    taxTitle: 'Taxe de séjour',
    nights: 'Nombre de nuits',
    taxableGuests: 'Hôtes taxables (14+ ans)',
    taxRate: 'Tarif par nuit par personne',
    totalTax: 'Total taxe de séjour',
    commission: 'Frais de transaction',
    totalPayment: 'Total à payer',
    proceedPayment: 'Procéder au paiement',
    taxNote: 'La taxe de séjour est une contribution obligatoire imposée par la Commune et les autorités locales aux personnes séjournant dans des hébergements touristiques.',
    paymentTitle: 'Paiement de la taxe de séjour',
    paymentProcessing: 'Traitement du paiement en cours...',
    paymentRedirect: 'Vous serez redirigé vers le système de paiement sécurisé.',
    payNow: 'Payer maintenant',
    confirmTitle: 'Paiement effectué avec succès',
    confirmCheckingPayment: 'Vérification du paiement en cours...',
    safebox: 'Le code de la safebox pour récupérer les clés est:',
    saveCode: 'IMPORTANT: sauvegardez ou mémorisez ce code. Nous vous recommandons de faire une capture d\'écran de cette page.',
    instructions: 'Toutes les photos et les instructions pour rejoindre l\'appartement vous ont déjà été envoyées.',
    selfCheckin: 'Instructions Self Check-in',
    selfCheckinText: 'Utilisez le code ci-dessus pour ouvrir la safebox et récupérer les clés de votre appartement.',
  },
};

export default guestTranslations;
